import { useTranslation } from 'react-i18next'
import { Button, EditIcon, PaymentsIcon } from '@mercai/clever'

import { CardInfo } from '@/components'

import { formatCurrency, isSaleOrderEditable } from '@/helpers'

import styles from './card-order-logistic-cost.module.css'

import type { CardOrderLogisticCostProps } from './card-order-logistic-cost.type'

export const CardOrderLogisticCost = ({
  isLoading,
  shipment,
  totalQuantityShipment,
  onEdit,
  saleOrderStatus,
}: CardOrderLogisticCostProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('componentCardsOrderCenterShow')

  const isEditable = isSaleOrderEditable(saleOrderStatus)

  const getCostPerKg = () => {
    const totalCost =
      (Number(shipment?.customsCost) || 0) +
      (Number(shipment?.firstMileCost) || 0) +
      (Number(shipment?.lastMileCost) || 0)

    return formatCurrency(
      Number(totalCost) / (totalQuantityShipment || 1),
      'es-MX',
      'USD',
    )
  }

  return (
    <div className={styles.core}>
      <CardInfo
        isLoading={isLoading}
        icon={<PaymentsIcon />}
        title={t('orderLogisticCostShipmentTitle')}
        actions={
          isEditable &&
          onEdit && (
            <Button
              size="small"
              variant="ghost"
              className={styles.edit}
              onClick={onEdit}
            >
              {t('editLabel')}
              <EditIcon />
            </Button>
          )
        }
        items={[
          {
            label: t('orderLogisticCostShipmentFirstMileCost'),
            value: shipment?.firstMileCost
              ? formatCurrency(shipment?.firstMileCost, 'es-MX', 'USD')
              : '-',
          },
          {
            label: t('orderLogisticCostShipmentLastMileCost'),
            value: shipment?.lastMileCost
              ? formatCurrency(shipment?.lastMileCost, 'es-MX', 'USD')
              : '-',
          },
          {
            label: t('orderLogisticCostShipmentCustomsCost'),
            value: shipment?.customsCost
              ? formatCurrency(shipment?.customsCost, 'es-MX', 'USD')
              : '-',
          },
          {
            label: t('orderLogisticCostShipmentExtraCost'),
            value: shipment?.extraCost
              ? formatCurrency(shipment?.extraCost, 'es-MX', 'USD')
              : '-',
          },
          {
            label: t('orderLogisticCostShipmentExtraCostReason'),
            value: shipment?.extraCostReason
              ? shipment?.extraCostReason.map(
                  (val, index) =>
                    `${index > 0 ? ', ' : ''}${tEnums(`logistic_extra_cost_${val}`)}`,
                )
              : '-',
          },
          {
            label: t('orderLogisticCostShipmentCostPerKg'),
            value: getCostPerKg(),
          },
        ]}
      />
    </div>
  )
}
